// extracted by mini-css-extract-plugin
module.exports = {"boxLists":"_17DmaLNekYBFZSld6g5onZ","list":"_1Jm1pRBmYJ5KFeljR2Ra70","name":"_2Ge9aCzl60kTFh-yMQ8BnP","manage":"_3E2EDeGTyHod1kA1pLAMgQ"};